import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Loading from '../../loading'
import {
  Row, Col, Breadcrumb, BreadcrumbItem, FormGroup, Input, Label, Button, FormText, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import {
  createResponse, getResponses, previewPdf
} from '../../../actions/adminActions'
import Form from '../../../modules/Form'
import PropTypes from 'prop-types'
import RichField from '../../RichField'
import { FaFilePdf } from 'react-icons/fa'

class AdminResponseCreate extends Component {
  constructor (props) {
    super(props)
    this.previewPdf = this.previewPdf.bind(this)
    this.body = React.createRef(this.body)
    this.template = React.createRef(this.template)
  }

  componentDidMount (props) {
    this.props.getResponses()
  }

  previewPdf () {
    this.props.previewPdf(this.body.current.value, this.template.current.value)
  }

  render () {
    if (this.props.admin.responses !== null) {
      return (

        <div>
          <Row className='page-title'>
            <Col>
              <h1>Create Response</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem><Link to='/admin/responses'>Responses</Link></BreadcrumbItem>
                <BreadcrumbItem active>Create Response</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <div className='content'>
            <Row>
              <Col lg={{ size: 8, offset: 0 }}>
                <Form id='details' submit={this.props.createResponse}>
                  <FormGroup>
                    <Label for='name'>Name</Label>
                    <Input type='text' name='name' id={'name'} required placeholder='Name' />
                    <div className='invalid-feedback' />
                  </FormGroup>

                  <RichField name='response' id='response' innerRef={this.body} />
                  <Row>
                    <Col>
                      <FormGroup>
                        <FormText color='muted' className='ml-3'>
                          Within the template you may use the following variables:
                          <ul className='ml-3'>
                            <li><b>%appellant%</b> - for appellants's name</li>
                            <li><b>%adjudicator%</b> - for adjudicator's name</li>
                            <li><b>%issuedate%</b> - date of issue</li>
                            <li><b>%reg%</b> - car registration</li>
                            <li><b>%pcn%</b> - parking charge number</li>
                            <li><b>%date%</b> - today's date</li>

                          </ul>
                        </FormText>
                      </FormGroup>
                    </Col>
                    <Col className='text-right'>
                      <Button className='secondary' onClick={this.previewPdf} disabled={this.props.admin.pdfing}><FaFilePdf />Preview PDF <span className='spinning' /></Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for='category'>Category</Label>
                        <Input type='select' name='category' id={'category'} required>
                          <option value='Standard'>Standard</option>
                          <option value='Pay & Display'>Pay &amp; Display</option>
                          <option value='Blue Badge'>Blue Badge</option>
                          <option value='Permit'>Permit</option>
                          <option value='Unauthorised'>Unauthorised</option>
                          <option value='Cancellation'>Cancellation</option>
                          <option value='Out of time'>Out of time</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label for='type'>Type</Label>
                        <Input type='select' name='type' id={'type'} required>
                          <option value='both'>Email or PDF</option>
                          <option value='email'>Email</option>
                          <option value='pdf'>PDF</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for='show_payment_details'>Show payment button?</Label>
                        <Input type='select' name='show_payment_details' id={'show_payment_details'} required>
                          <option value='0'>No</option>
                          <option value='1'>Yes</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>

                      <FormGroup>
                        <Label for='payment_amount'>Payment Amount</Label>
                        <InputGroup>
                          <InputGroupAddon addonType='prepend'>
                            <InputGroupText>&pound;</InputGroupText>
                          </InputGroupAddon>
                          <Input name='payment_amount' id='payment_amount' type='number' min='0' step='0.01' defaultValue={'0'} />
                        </InputGroup>
                        <div className='invalid-feedback' />
                      </FormGroup>
                      <FormGroup>
                        <Label for='after_reply_status'>After sending set the following status:</Label>
                        <Input type='select' defaultValue={'pending appellant response'} name='after_reply_status' id={'after_reply_status'} >
                          <option value='registering'>Registering</option>
                          <option value='registered'>Registered</option>
                          <option value='submitted'>Submitted</option>
                          <option value='writing'>Writing</option>
                          <option value='pending appellant response'>Pending appellant response</option>
                          <option value='pending adjudicator response'>Pending adjudicator response</option>
                          <option value='accepted'>Accepted</option>
                          <option value='rejected'>Rejected</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label for='time_limit'>Time Limit? (0 = no limit)</Label>
                        <InputGroup>
                          <Input type='number' step='1' name='time_limit' id={'time_limit'} defaultValue={0} />
                          <InputGroupAddon addonType='append'>
                            <InputGroupText>days</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        <div className='invalid-feedback' />
                      </FormGroup>

                      <FormGroup>
                        <Label for='time_limit_template'>After time limit send following response:</Label>
                        <Input type='select' name='time_limit_template' id={'time_limit_template'}>
                          <option>None</option>
                          {this.props.admin.responses.map((response, index) => (
                            <option key={index} value={response.id}>{response.name}</option>
                          ))}
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>

                      <FormGroup>
                        <Label for='time_limit_status'>After time limit set following status:</Label>
                        <Input type='select' name='time_limit_status' id={'time_limit_status'}>
                          <option>None</option>
                          <option value='registering'>Registering</option>
                          <option value='registered'>Registered</option>
                          <option value='submitted'>Submitted</option>
                          <option value='writing'>Writing</option>
                          <option value='pending appellant response'>Pending appellant response</option>
                          <option value='pending adjudicator response'>Pending adjudicator response</option>
                          <option value='accepted'>Accepted</option>
                          <option value='rejected'>Rejected</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for='pdf_template'>PDF Template</Label>
                        <Input innerRef={this.template} type='select' name='pdf_template' id={'pdf_template'} required>
                          <option value='lettehead'>Letterhead only</option>
                          <option value='reminder'>Reminder</option>
                          <option value='rejection'>Rejection</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                    <Col />
                  </Row>

                </Form>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                <Button color='primary' form='details' disabled={this.props.admin.submitting}>Create <span className='spinning' /></Button>
              </Col>
            </Row>
          </div>
        </div>
      )
    } else {
      return (<Loading />)
    }
  }
}

AdminResponseCreate.propTypes = {
  createResponse: PropTypes.func,
  getResponses: PropTypes.func,
  admin: PropTypes.object,
  previewPdf: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createResponse,
      getResponses,
      previewPdf
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminResponseCreate))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminResponses/AdminResponseCreate.jsx